/**
 * 队列管理器
 */

export class QueueManager<T> {
  private queue: T[] = []

  push(item: T, callback?: (item: T) => void): void {
    this.queue.push(item)
    if (typeof callback === 'function') {
      callback(item)
    }
  }

  shift(len: number): T[] {
    if (typeof len === 'number' && len > 0) {
      return this.queue.splice(0, len)
    }
    return []
  }

  get length(): number {
    return this.queue.length
  }

  clear(): void {
    this.queue.length = 0
  }

  getAll(): T[] {
    return [...this.queue]
  }
}
